import React from "react";

const SecondaryHeader = ({ children }) => (
  <div className="header__secondary">
    <div className="content-body">{children}</div>
  </div>
);
export default SecondaryHeader;
